// extracted by mini-css-extract-plugin
export default {"wrapper":"Location_wrapper__oKNVC","container":"Location_container__CBtyL"};